import * as yup from 'yup'

export const customerValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    namaCustomer: yup.string().required('Harus diisi'),
    alamat: yup.string().required('Harus diisi'),
    email: yup.string().email('Email harus valid').required('Harus diisi'),
    telepon: yup.string().required('Harus diisi'),
    fax: yup.string().required('Harus diisi'),
    latitude: yup.number('Harus angka').required('Harus diisi'),
    longitude: yup.number().required('Harus diisi'),
    provinceId: yup.string().required('Harus diisi'),
    regencyId: yup.string().required('Harus diisi'),
    districtId: yup.string().required('Harus diisi'),
    villageId: yup.string().required('Harus diisi'),
    dataPICIds: yup.array().min(1, 'Minimal 1 PIC').required('Harus diisi'),
    // Keduanya opsional: penanda di luar PP 73 dan catatan tujuan penggunaan.
    diLuarPP73: yup.boolean(),
    tujuanPenggunaan: yup.string().nullable(),
}).required()